import { render, staticRenderFns } from "./RatioInfo.vue?vue&type=template&id=6323a4c5&"
import script from "./RatioInfo.vue?vue&type=script&lang=js&"
export * from "./RatioInfo.vue?vue&type=script&lang=js&"
import style0 from "./RatioInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports